import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';

import TicketOptionsSectionItem from 'flow/components/tickets/ticket-info-section/options-section/TicketOptionsSectionItem';
import TicketAccessSection from 'flow/components/tickets/ticket-info-section/access/TicketAccessSection';
import TicketTagsList from 'flow/components/tickets/TicketTagsList';

interface Props {
    ticketKey: TicketKey;
}

const DetailsSection = ({ ticketKey }: Props) => {
    return (
        <div className="flex flex-col gap-y-6 pb-3">
            <TicketOptionsSectionItem ticketKey={ticketKey} />
            <TicketAccessSection ticketKey={ticketKey} />
            <TicketTagsList ticketKey={ticketKey} />
        </div>
    );
};

export default React.memo(DetailsSection);
